var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_523_249",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_523_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99961 18L5.59961 16.6L10.1996 12L5.59961 7.4L6.99961 6L12.9996 12L6.99961 18ZM15.9996 18V6H17.9996V18H15.9996Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPage);
export default __webpack_public_path__ + "static/media/lastPage.988b58d9a69a11707a98a537a80a6b1b.svg";
export { ForwardRef as ReactComponent };